export default {

    /*
     * TTL Core API's notification channels for farmers
     */
    Farmers: 'core_farmers_notifications',

    /*
     * TTL Core API's notification channels for administrators
     */
    Admin: 'core_admin_notifications',

    /*
     * TTL Core API's notification channels for fbo
     */
    Fbo: 'core_fbo_notifications',

    /*
     * TTL Core API's notification channels for fbo
     */
    Media :'core_media_notifications',

    /*
     * TTL Core API's notification channels for messages
     */
    Messages: 'core_messages_notifications',

    /*
     * TTL Core API's notification channels for operators
     */
    Operators: 'core_operator_notifications',

    /*
     * TTL Core API's notification channels for tractors
     */
    Tractor: 'core_tractor_notifications',

    /*
     * TTL Core API's notification channels for tractor owner
     */
    TractorOwner: 'core_owner_notifications',

    /*
     * TTL Core API's notification channels for tractor requests
     */
    TractorRequests: 'core_tractor_request_notifications',

    /*
     * TTL Core API's notification channels for tractor request messages
     */
    TractorRequestMessages: 'core_request_message_notifications',

    /*
     * TTL Core API's notification channels for operator requests
     */
    OperatorRequests: 'core_operator_request_notifications',

    /*
     * TTL Core API's notification channels for User Notifications
     */
    UserNotification: 'core_notifications_channel',

    /*
     * TTL Core API's notification channels for users
     */
    Users : 'core_users_notifications',

    /*
     * TTL Core API's notification channels for transactions
     */
    Transactions: 'core_transactions_notifications',

    /**
     * TTL Core API's notification channels for payments
     */
    Payments: 'core_payments_channel'

}


// WEBPACK FOOTER //
// ./src/common/NotificationChannels.js